import io from "socket.io-client";
// const options = { autoConnect: false, reconnection: true };
export default class UploadSocketManager {
    constructor(url, options = {}) {
        const socket = io(url, options);
        socket.on("connect", () => {});
        socket.on("disconnect", () => {});
        this.socket = socket;
    }

    connect() {
        const socket = this.socket;
        if (socket) {
            if (!socket.connected & socket.disconnected) {
                socket.connect();
            }
        }
    }

    disconnect() {
        const socket = this.socket;
        if (socket) {
            if (socket.connected) {
                socket.off("monitor");
                socket.disconnect();
            } else {
                socket.disconnect();
            }
        }
    }

    getTableData(companyId, setData, setMessage, setLoader) {
        const socket = this.socket;
        if (!socket) return true;
        socket.on("monitor", ({
            data = [],
            message = []
        }) => {
            setLoader(false);
            setData(data);
            setMessage((message && message[0]) || {
                type: "",
                text: ""
            });
        });

        socket.emit("monitor", companyId);
        setLoader(true);
    }

    cancelProcess(companyId, processId) {
        const socket = this.socket;
        if (!socket) return true;
        socket.emit("cancel", companyId, processId);
    }

    removeProcess(companyId, processId) {
        const socket = this.socket;
        if (!socket) return true;
        socket.emit("remove", companyId, processId);
    }

    restartProcess(companyId, processId) {
        const socket = this.socket;
        if (!socket) return true;
        socket.emit("restart", companyId, processId);
    }

    retryProcess(companyId, processId) {
        const socket = this.socket;
        if (!socket) return true;
        socket.emit("retry", companyId, processId);
    }
}